var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Captcha"},[_c('Verify',{ref:"verify",attrs:{"captcha-type":_vm.captchaType,"img-size":{ width: '330px', height: '155px' },"mode":'pop',"show":_vm.show,"withCredentials":_vm.withCredentials},on:{"success":_vm.success,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }